/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import firebase from 'firebase/app'
import 'firebase/auth'
import router from '@/router'
import EventEmitter from 'events';
import axios from 'axios'
import store from '../../store/store'
const localStorageKey = 'loggedIn';
const loginEvent = 'loginEvent';
const tokenExpiryKey = 'tokenExpiry';


export default {


    loginAttempt({ dispatch }, payload) {
        const newPayload = {
            userDetails: payload.userDetails,
            notify: payload.notify,
			close_load: payload.close_load
        }
        if (!payload.checkbox_remember_me) {
            // localStorage.setItem('remember_me', false);
            firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
                .then(function() {
                    dispatch('login', newPayload)
                })
                .catch(function(err) {
                    payload.notify({
                        time: 2500,
                        title: 'Error',
                        text: err.message,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
        } else {
            // localStorage.setItem('remember_me', true);
            dispatch('login', newPayload)
        }
    },
    login({ commit, state }, payload) {
        if (state.isUserLoggedIn()) {
            payload.notify({
                title: 'Autenticação',
                text: 'Você já está logado!',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
            });
            payload.close_load.close();
            return false
        }

		fetch(store.state.API_URL+'Login', {
			method: 'POST',
			headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
			body: "username="+payload.userDetails.email+"&password="+payload.userDetails.password
		})
		.then((response) => response.text())
		.then((responseData) => {
			payload.close_load.close();
			var dados = JSON.parse(responseData);
			if(dados.success == false)
			{
				payload.notify({
                    time: 2500,
                    title: 'Error',
                    text: dados.message,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
			}
			else if(dados.success == true)
			{
				this.idToken = dados.token;
				this.profile = dados.dados;

				// Convert the JWT expiry time from seconds to milliseconds
				this.tokenExpiry = new Date((new Date().getTime()+86400000));
				localStorage.setItem(tokenExpiryKey, this.tokenExpiry);
				localStorage.setItem("token", this.idToken);
				localStorage.setItem(localStorageKey, 'true');
				localStorage.setItem('userRole', this.profile.rule);
        //$acl.change(this.profile.rule);
				localStorage.setItem('userInfo', JSON.stringify({
					displayName: this.profile.nome,
					Login: this.profile.login,
					plan: this.profile.combo,
					email: this.profile.email_candidato,
					photoURL: this.profile.foto_perfil,
					providerId: this.profile.id,
					uid: this.profile.id
				}));

				//commit('UPDATE_AUTHENTICATED_USER', result.user.providerData[0])
				router.push(router.currentRoute.query.to || '/');
			}
		})
		.catch((error) => {
      console.log(error)
			payload.close_load.close();
			payload.notify({
				time: 2500,
				title: 'Error',
				text: "Verifique a sua conexão.",
				iconPack: 'feather',
				icon: 'icon-alert-circle',
				color: 'danger'
			});
		});
        /*firebase.auth().signInWithEmailAndPassword(payload.userDetails.email, payload.userDetails.password)
            .then((result) => {
                router.push(router.currentRoute.query.to || '/');
                commit('UPDATE_AUTHENTICATED_USER', result.user.providerData[0])
            }, (err) => {
                payload.notify({
                    time: 2500,
                    title: 'Error',
                    text: err.message,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })*/
    },

    // Google Login
    loginWithGoogle({commit, state}, payload) {
        if (state.isUserLoggedIn()) {
            payload.notify({
                title: 'Login Attempt',
                text: 'You are already logged in!',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
            });
            return false
        }
        const provider = new firebase.auth.GoogleAuthProvider();

        firebase.auth().signInWithPopup(provider)
            .then((result) => {
                router.push(router.currentRoute.query.to || '/');
                commit('UPDATE_AUTHENTICATED_USER', result.user.providerData[0])
            }).catch((err) => {
                payload.notify({
                    time: 2500,
                    title: 'Error',
                    text: err.message,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        firebase.auth().onAuthStateChanged(function(user) {
            if (user) {
                user.updateProfile({
                    roles: ['admin'],
                }).then(function() {
                    // Profile updated successfully!
                    // Login user
                    console.log('success');
                    // this.$vs.notify({
                    //     title: 'Success',
                    //     text: "done",
                    //     iconPack: 'feather',
                    //     icon: 'icon-check',
                    //     color: 'success'
                    // });
                }, function(error) {
                    console.log("uiiiiiiiii");
                    console.log(error.message);
                    // this.$vs.notify({
                    //     title: 'Error',
                    //     text: error.message,
                    //     iconPack: 'feather',
                    //     icon: 'icon-alert-circle',
                    //     color: 'danger'
                    // });
                });

            }
        });
    },

    // Facebook Login
    loginWithFacebook({commit, state}, payload) {
        if (state.isUserLoggedIn()) {
            payload.notify({
                title: 'Login Attempt',
                text: 'You are already logged in!',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
            });
            return false
        }
        const provider = new firebase.auth.FacebookAuthProvider();

        firebase.auth().signInWithPopup(provider)
            .then((result) => {
                router.push(router.currentRoute.query.to || '/');
                commit('UPDATE_AUTHENTICATED_USER', result.user.providerData[0])
            }).catch((err) => {
                payload.notify({
                    time: 2500,
                    title: 'Error',
                    text: err.message,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
    },

    // Twitter Login
    loginWithTwitter({commit, state}, payload) {
        if (state.isUserLoggedIn()) {
            payload.notify({
                title: 'Login Attempt',
                text: 'You are already logged in!',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
            });
            return false
        }
        const provider = new firebase.auth.TwitterAuthProvider();

        firebase.auth().signInWithPopup(provider)
            .then((result) => {
                router.push(router.currentRoute.query.to || '/');
                commit('UPDATE_AUTHENTICATED_USER', result.user.providerData[0])
            }).catch((err) => {
                payload.notify({
                    time: 2500,
                    title: 'Error',
                    text: err.message,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
    },

    // Github Login
    loginWithGithub({commit, state}, payload) {
        if (state.isUserLoggedIn()) {
            payload.notify({
                title: 'Login Attempt',
                text: 'You are already logged in!',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
            });
            return false
        }
        const provider = new firebase.auth.GithubAuthProvider();

        firebase.auth().signInWithPopup(provider)
            .then((result) => {
                router.push(router.currentRoute.query.to || '/');
                commit('UPDATE_AUTHENTICATED_USER', result.user.providerData[0])
            }).catch((err) => {
                payload.notify({
                    time: 2500,
                    title: 'Error',
                    text: err.message,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
    },
    updateAuthenticatedUser({ commit }, payload) {
        commit('UPDATE_AUTHENTICATED_USER', payload)
    }
}
